import { ApiCallStorageInterface } from "./ApiCallStorageInterface";
class ApiCallStorage extends ApiCallStorageInterface {
  constructor() {
    super();
    this.storage = {};
  }
  register = (name, value) => {
    this.set(name, value);
    return this;
  };
  get = name => {
    return this.storage[name];
  };
  set = (name, value) => {
    this.storage[name] = value;
    return this;
  };
}
export { ApiCallStorage };